
import { Reaction } from '@padlet/arvo'
import { Component, namespace, Prop, Vue } from 'bits/vue'
import OzIcon from 'library/v4/components/OzIcon.vue'
import OzTextButton, { OzTextButtonColorScheme } from 'library/v4/components/OzTextButton.vue'
import uniqueId from 'lodash.uniqueid'
import type { Cid, Id } from 'types'
import emitClickOnTouch from 'vuedirectives/emit_click_on_touch'

const reaction = namespace('reaction')
const snackbars = namespace('snackbars')

@Component({
  components: {
    OzIcon,
    OzTextButton,
  },
  directives: {
    emitClickOnTouch,
  },
})
export default class SurfacePostReactionVoteNew extends Vue {
  OzTextButtonColorScheme = OzTextButtonColorScheme

  @Prop({ required: true }) reactionIds!: string[]
  @Prop({ required: true }) myReactionId!: string | undefined
  @Prop({ required: true }) isPadletColorSchemeDark!: boolean
  @Prop({ required: true }) canReact!: boolean
  @Prop({ required: true }) postCid!: Cid
  @Prop({ default: 'postView' }) usageContext!: 'postView' | 'postExpandedView'

  @namespace('browser').Getter isSmallerThanTabletPortrait!: boolean
  @reaction.Getter reactionEntities!: Record<Id, Reaction>

  get upvoteButtonId(): string {
    return `upvote-button-description-${this.postCid}-${uniqueId('upvotePostButton')}`
  }

  get downvoteButtonId(): string {
    return `downvote-button-description-${this.postCid}-${uniqueId('downvotePostButton')}`
  }

  get isUsedInPostExpandedView(): boolean {
    return this.usageContext === 'postExpandedView'
  }

  get iconSize(): number {
    return this.isUsedInPostExpandedView ? (this.isSmallerThanTabletPortrait ? 24 : 20) : 18
  }

  get upvoteCount(): number {
    return this.reactionIds.filter((id) => (this.reactionEntities[id] as Reaction).value === 1).length
  }

  get downvoteCount(): number {
    return this.reactionIds.filter((id) => (this.reactionEntities[id] as Reaction).value === -1).length
  }

  get currentUserUpvoted(): boolean {
    return !!this.myReactionId && (this.reactionEntities[this.myReactionId] as Reaction).value === 1
  }

  get currentUserDownvoted(): boolean {
    return !!this.myReactionId && (this.reactionEntities[this.myReactionId] as Reaction).value === -1
  }

  @snackbars.Action setSnackbar!: (payload: { message: string }) => void

  publishReaction(value): void {
    this.$emit('create', value)
  }

  removeReaction(): void {
    this.$emit('delete')
  }

  showReactionOffNotice(): void {
    const message = this.__('Reactions have been disabled by the admin.')
    this.setSnackbar({ message })
  }

  toggleVote(isUpvote: boolean): void {
    if ((isUpvote && this.currentUserUpvoted) || (!isUpvote && this.currentUserDownvoted)) {
      this.removeReaction()
    } else if (this.canReact) {
      this.publishReaction(isUpvote ? 1 : -1)
    } else {
      this.showReactionOffNotice()
    }
  }

  toggleUpvote(): void {
    this.toggleVote(true)
  }

  toggleDownvote(): void {
    this.toggleVote(false)
  }
}
